import {
    defaultTypeSubCategory,
    defaultFilterTypesSubCategoriesSga,
} from "./state";

/**
 * Mutación que establece los tipos de subcategorías de SGA.
 *
 * @param {*} state.typesSubCategoriesSga - Estado de los tipos de subcategorías de SGA.
 * @param typesSubCategoriesSga - Tipos de subcategorías de SGA.
 * @return {void}
 * @author Brandon Torres
 */
export function setTypesSubCategoriesSga(state, typesSubCategoriesSga) {
    state.typesSubCategoriesSga = typesSubCategoriesSga;
}

/**
 * Mutación que establece la acción a realizar (Crear o actualizar).
 *
 * @param {*} state.action - Estado de la acción.
 * @param action - Acción a realizar (create o edit).
 * @return {void}
 * @author Brandon Torres
 */
export function setActionTypeSubCategorySga(state, action) {
    state.action = action;
}

/**
 * Mutación que establece el tipo de subcategoría por defecto.
 *
 * @param {*} state.typeSubCategory - Estado del tipo de subcategoría.
 * @return {void}
 * @author Brandon Torres
 */
export function setDefaultTypeSubCategorySga(state) {
    state.typeSubCategory = defaultTypeSubCategory();
}

/**
 * Mutación que establece el filtro de los tipos de subcategorías de SGA por defecto.
 *
 * @param {*} state.filterTypesSubCategoriesSga - Estado del filtro los tipos de subcategorías de SGA.
 * @return {void}
 * @author Brandon Torres
 */
export function setDefaultFilterTypesSubCategories(state) {
    state.filterTypesSubCategoriesSga = defaultFilterTypesSubCategoriesSga();
}

/**
 * Mutación que establece la cantidad de los tipos de subcategorías por página.
 *
 * @param {*} state.filterTypesSubCategoriesSga.per_page - Cantidad de registros por página.
 * @param {*} state.filterTypesSubCategoriesSga.page - Página actual.
 * @param per_page - Cambio de cantidad de registros por página.
 * @return {void}
 * @author Brandon Torres
 */
export function loadAfterChangeSizePagination(state, per_page) {
    state.filterTypesSubCategoriesSga = {
        ...state.filterTypesSubCategoriesSga,
        page: 1,
        per_page: per_page,
    };
}

/**
 * Mutación que establece la página actual.
 *
 * @param {*} state.filterTypesSubCategoriesSga.page - Página actual.
 * @param page - Cambio de página actual.
 * @return {void}
 * @author Brandon Torres
 */
export function loadAfterChangePagePagination(state, page) {
    state.filterTypesSubCategoriesSga.page = page;
}

/**
 * Mutación que establece el paginador de registros de los tipos de subcategorías.
 *
 * @param {*} state.filterTypesSubCategoriesSga.page - Página actual.
 * @param {*} state.filterTypesSubCategoriesSga.per_page - Cantidad de registros por página.
 * @param {*} state.filterTypesSubCategoriesSga.total - Total de registros.
 * @param paginate - Paginación de registros.
 * @return {void}
 * @author Brandon Torres
 */
export function setPaginateTypesSubCategoriesSga(state, paginate) {
    state.filterTypesSubCategoriesSga = {
        ...state.filterTypesSubCategoriesSga,
        page: paginate.current_page,
        per_page: paginate.per_page,
        total: paginate.total,
    };
}

/**
 * Mutación que establece el tipo de subcategoría de SGA.
 *
 * @param {*} state.typeSubCategory - Estado del tipo de subcategoría.
 * @param typeSubCategory - Tipo de subcategoría de SGA.
 * @return {void}
 * @author Brandon Torres
 */
export function setTypeSubCategorySga(state, typeSubCategory) {
    state.typeSubCategory = {
        id: typeSubCategory.id,
        name: typeSubCategory.name,
        sga_sub_category_type_languages:
            typeSubCategory.sga_sub_category_type_languages,
    };
}

/**
 * Mutación que establece los tipos de subcategorías activas de SGA.
 *
 * @param {*} state.activeTypesSubCategories - Estado de los tipos de subcategorías activas de SGA.
 * @param activeTypesSubCategories - Tipos de subcategorías activas de SGA.
 * @return {void}
 * @author Brandon Torres
 */
export function setActiveTypesSubCategoriesSga(
    state,
    activeTypesSubCategories
) {
    state.activeTypesSubCategories = activeTypesSubCategories;
}
